module.exports = __webpack_public_path__ + "static/media/engine-small-second.7de08d8e.jpg";